interface SingularOrPlural {
	plural: string;
	singular: string;
}

interface DocumentSetData {
	docTypes: string[];
	long: SingularOrPlural;
	short: SingularOrPlural;
}

export class DocumentSet implements DocumentSetData {
	public constructor(data: DocumentSetData) {
		Object.assign(this, data);
	}

	public readonly docTypes: string[];
	public readonly long: SingularOrPlural;
	public readonly short: SingularOrPlural;

	public pluralize(count: number, format: 'long' | 'short'): string {
		const longOrShort: SingularOrPlural = this[format];
		return count === 1 ? longOrShort.singular : longOrShort.plural;
	}
}

export const DocumentSets = {
	none: new DocumentSet({
		docTypes: [],
		long: {
			plural: 'none',
			singular: 'none',
		},
		short: {
			plural: 'none',
			singular: 'none',
		},
	}),

	policyForms: new DocumentSet({
		docTypes: ['PP'],
		long: {
			plural: 'Policy Forms',
			singular: 'Policy Form',
		},
		short: {
			plural: 'Policy Forms',
			singular: 'Policy Form',
		},
	}),

	endorsements: new DocumentSet({
		docTypes: ['EDS'],
		long: {
			plural: 'Endorsements',
			singular: 'Endorsement',
		},
		short: {
			plural: 'Endorsements',
			singular: 'Endorsement',
		},
	}),

	cois: new DocumentSet({
		docTypes: ['COI'],
		long: {
			plural: 'Certificates of Insurance',
			singular: 'Certificate of Insurance',
		},
		short: {
			plural: 'COIs',
			singular: 'COI',
		},
	}),

	stateFundForms: new DocumentSet({
		docTypes: ['NBC', 'PFF'],
		long: {
			plural: 'State Fund Forms',
			singular: 'State Fund Form',
		},
		short: {
			plural: 'State Fund Forms',
			singular: 'State Fund Form',
		},
	}),
};

type TypeCheck<T extends Record<string, DocumentSet>> = T;
type TypeChecked = TypeCheck<typeof DocumentSets>;
